export const Heading: React.FC<any> = ({ text, children }) => {
  return (
    <div className="mt-4 p-6 pl-3 flex flex-row justify-between bg-gray-100 dark:bg-gray-700 rounded-md ">
      <h1 className="text-xl font-bold leading-tight text-gray-900 dark:text-gray-100">
        {text}
      </h1>
      <div className="flex flex-row gap-5">{children}</div>
    </div>
  );
};

